import Header from "../components/Header";
import React, {useEffect, useState} from "react";
import Container from '@mui/material/Container';
import UnionForm from "../components/UnionContactForm";

const QRCode = (props) => {
    const targetDate = new Date(2025, 9, 11)


    const calculateTimeLeft = (targetDate) => {
        const difference = +new Date(targetDate) - +new Date();
        let timeLeft = {};

        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        }
        return timeLeft;
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(targetDate));

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft(targetDate));
        }, 1000);

        return () => clearInterval(timer); // Cleanup function
    }, [targetDate]); // Re-run effect if targetDate changes
    return (
        <>
            <Header title="All Craft Conference" sections={props.sections}/>
            <Container>
                <div className="full-width-centered, text-center">
                    <picture>
                        <source media="(min-width: 650px)" srcSet="/image/Rachelle.png"/>
                        <source media="(min-width: 330px) " srcSet="/image/RachelleSmall.png"/>
                        <source media="(min-width: 100px) " srcSet="/image/RachelleTiny.png"/>
                        <img src="/image/Rachelle.png" alt="Rachelle Profile Photo"/>
                    </picture>
                </div>
                <h1 className="full-width-centered, text-center">Hi There!</h1>
                <p>Thanks for scanning! I'm Rachelle. I serve as the NYS APWU WNY steward covering all MALs in 140-149.
                    I’m in Las Vegas this week, meeting APWU leaders who want to cut costs and streamline operations.
                    Let’s collaborate on making APWU stronger, one solution at a time.</p>

                <p>Watch a 47‑second demo of Bear aTACS by filling out the form below. It’s a cloud‑based tool that
                    simplifies TACS grievance calculations. Complete the form, and you’ll unlock a 50% discount on your
                    first year of service. &nbsp;&nbsp;
                    {Object.keys(timeLeft).length > 0 ? (
                        <>
                            <span>{timeLeft.days}d </span>
                            <span>{timeLeft.hours}h </span>
                            <span>{timeLeft.minutes}m </span>
                            <span>{timeLeft.seconds}s</span>
                            <p>Act now before times runs out to claim the 50% first year discount!</p></>
                    ) : (
                        <p>Time's up to automatically qualify for this discount. Fill out the form to find out about
                            future discounts.</p>
                    )}
                </p>
                <UnionForm/>

                <hr/>
                <p>Not here for the APWU All Craft Conference but still want to talk tech? That's good with us too! Come
                    say hi.
                </p>
            </Container>
        </>);
}


export default QRCode;